const actionNamespace = 'brc/';


export const createActionType = (base) => {
    base = base.toUpperCase();
    return `${actionNamespace}${base}`;
};

export const createRequestTypes = (base) => {
    return {
        REQUEST : createActionType(`${base}_REQUEST`),
        SUCCESS : createActionType(`${base}_SUCCESS`),
        ERROR   : createActionType(`${base}_ERROR`)
    };
};
